<div class="gel__text-center mt-5">
  <h1>Error 403 - Forbidden Access.</h1>
  <h3>
    You will be redirected to the <a [attr.href]="loginUrl">Login Page</a> in
    {{ countdown }}
  </h3>
</div>
